import { useEffect } from 'react';

import { useNavigate } from 'react-router';

import { Loader } from '@trendiolive/trendio-selfcare-ui-kit';

import useAuth from 'hooks/useAuth';

import { GuardProps } from 'model/types/auth';

import { APP_DEFAULT_PATH } from 'constants/appConstants';

export default function InitGuard({ children }: Readonly<GuardProps>) {
  const { authInProgress, user, userRole } = useAuth();

  const navigate = useNavigate();

  const userNotLoaded = user === undefined || user === null;
  useEffect(() => {
    if (authInProgress || userNotLoaded) return;

    const userIsMultimerchant = user?.roles && user?.roles?.length > 1;

    if (userRole) {
      navigate(APP_DEFAULT_PATH, {
        state: {
          from: ''
        },
        replace: true
      });
    } else if (userIsMultimerchant) {
      navigate('/merchant-select', {
        state: {
          from: ''
        },
        replace: true
      });
    } else {
      navigate('/login', {
        state: {
          from: ''
        },
        replace: true
      });
    }
  }, [authInProgress, navigate, user, userRole]);

  if (authInProgress) return <Loader />;

  return children;
}
